export enum LabelType {
  RECTANGLE = 'RECTANGLE',
  POLYGON = 'POLYGON',
}
